module.exports = __webpack_public_path__ + "img/auto-response.543ac075.png";